export function GetJsonWithCred(url: string, cache?: boolean) {
    let req: any;
    req = {
        url: url,
        type: "GET",
        dataType: 'json',
        xhrFields: {
            withCredentials: true
        }
    };

    if (!cache) {
        req.cache = cache;
    }

    return $.ajax(req);
}

export function postJSON(url: string, data: any, withCred?: boolean) {
    let request: any = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        url: url,
        type: 'POST',
        data: JSON.stringify(data),
        dataType: 'json',
        contentType: 'application/json'
    };

    if (withCred) {
        request.xhrFields = {
            withCredentials: true
        };
    }
    return $.ajax(request);
}

export function deleteJSON(url: string, withCred?: boolean) {
    const request = {
        url: url,
        type: 'DELETE'
    } as any;

    if (withCred) {
        request.xhrFields = {
            withCredentials: true
        };
    }

    return $.ajax(request);
}